import {
  FETCH_MARKERS_BEGIN,
  FETCH_MARKERS_SUCCESS,
  FETCH_MARKERS_FAILURE,
  UPDATE_MARKER,
  SET_SELECTED_MARKER,
  CLEAR_SELECTED_MARKER,
} from "../actions/Map";

const initialState = {
  markers: [],
  selectedMarker: {},
  loading: false,
  error: null,
};

export default function mapReducer(state = initialState, action) {
  switch (action.type) {
    case SET_SELECTED_MARKER:
      return {
        ...state,
        selectedMarker: {...action.payload},
      };
    case CLEAR_SELECTED_MARKER:
      return {
        ...state,
        selectedMarker: {},
      };
    case FETCH_MARKERS_BEGIN:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_MARKERS_SUCCESS:
      return {
        ...state,
        loading: false,
        markers: action.payload,
      };

    case FETCH_MARKERS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        markers: [],
      };

    case UPDATE_MARKER:
      const newMarkers = state.markers.map((marker) =>
        marker.id === action.payload.id ? { ...action.payload } : marker
      );
      return {
        ...state,
        markers: newMarkers
      };

    default:
      return state;
  }
}
